const getDefaultState = () => {
  return {
    tools: {
      testFiltering: null,
      dns: null,
    },
  };
};
// initial state
const state = getDefaultState();

const requestUrl = `/restapi/tools/test/category`;

const getters = {
  toolsTestFiltering(state) {
    return state.tools.testFiltering;
  },
  toolsDns(state) {
    return state.tools.dns;
  },
};

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  updateTestFilering: (state, data) => (state.tools.testFiltering = data),
  updateDnsFiltering: (state, data) => (state.tools.dns = data),
};

const actions = {
  clearCache({ commit }) {
    commit("resetState");
  },
  async checkTestFiltering({ commit }, testFiltering) {
    const response = await this._vm.$http.post(requestUrl, testFiltering);
    const data = response.data.categories.map((res) => res.categories);
    const mergedArrays = [].concat.apply([], data);
    const removeDublicates = [...new Set(mergedArrays)];

    commit("updateTestFilering", removeDublicates);
  },

  async dnsLookUp({ commit }, dns) {
    const response = await this._vm.$http.get(
      `/restapi/tools/dns?domain=${dns}`
    );

    commit("updateDnsFiltering", response.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
